import { getOperatorsForField, OPEN_PO_CONDITION_FIELDS, ESTIMATION_AP_CONDITION_FIELDS } from './accrualsConfigurationConstants';

export const EMPTY_VALUE_OPERATORS = ['is_empty', 'is_not_empty'];

export const CONDITION_ERRORS = {
  FIELD_REQUIRED: 'Select a field',
  FIELD_INVALID: 'Field is not a canonical Open PO column',
  OPERATOR_REQUIRED: 'Select an operator',
  OPERATOR_INVALID: 'Operator is not allowed for this field',
  VALUE_REQUIRED: 'Enter a value',
  VALUE_NUMBER: 'Enter a valid number',
  VALUE_DATE: 'Enter a valid date',
};

export const OWNER_ID_ERROR = 'Enter a valid 24-character owner id';
export const OWNER_ID_PATTERN = /^[a-fA-F0-9]{24}$/;

export const CONDITIONS_INCOMPLETE_MESSAGE = 'Fix all conditions before saving';

export function getFieldMeta(fieldValue) {
  return OPEN_PO_CONDITION_FIELDS.find((f) => f.value === fieldValue)
    || ESTIMATION_AP_CONDITION_FIELDS.find((f) => f.value === fieldValue)
    || null;
}

export function isEmptyValueOperator(operator) {
  return EMPTY_VALUE_OPERATORS.includes(operator);
}

export function formatConditionValue(fieldType, value) {
  if (value === null || value === undefined || value === '') return '';
  if (fieldType === 'date') {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toISOString().slice(0, 10);
  }
  return String(value);
}

function validateConditionValue(fieldType, operator, value) {
  if (isEmptyValueOperator(operator)) return '';
  const raw = value === null || value === undefined ? '' : String(value).trim();
  if (!raw) return CONDITION_ERRORS.VALUE_REQUIRED;
  if (fieldType === 'number') {
    const n = Number(raw.replace(/,/g, ''));
    if (Number.isNaN(n)) return CONDITION_ERRORS.VALUE_NUMBER;
  }
  if (fieldType === 'date') {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return CONDITION_ERRORS.VALUE_DATE;
  }
  return '';
}

export function validateCondition(condition) {
  const errors = { field: '', operator: '', value: '' };
  const field = condition?.field;
  const operator = condition?.operator || condition?.op;
  const meta = getFieldMeta(field);

  if (!field) {
    errors.field = CONDITION_ERRORS.FIELD_REQUIRED;
  } else if (!meta) {
    errors.field = CONDITION_ERRORS.FIELD_INVALID;
  }

  if (!operator) {
    errors.operator = CONDITION_ERRORS.OPERATOR_REQUIRED;
  } else if (meta) {
    const allowed = getOperatorsForField(field).map((item) => item.value);
    if (!allowed.includes(operator)) {
      errors.operator = CONDITION_ERRORS.OPERATOR_INVALID;
    }
  }

  if (!errors.field && !errors.operator) {
    errors.value = validateConditionValue(meta?.type, operator, condition?.value);
  }

  return {
    valid: !errors.field && !errors.operator && !errors.value,
    errors,
  };
}

export function validateConditions(conditions) {
  const errorsByIndex = {};
  let valid = true;
  (conditions || []).forEach((condition, index) => {
    const result = validateCondition(condition);
    errorsByIndex[index] = result.errors;
    if (!result.valid) valid = false;
  });
  return { valid, errorsByIndex };
}

/**
 * Validate one-level IM groups. errorsByKey uses `${groupId}:${condIndex}`.
 * @param {Array} groups
 * @returns {{ valid: boolean, errorsByKey: Object, flatConditions: Array }}
 */
export function validateImGroups(groups) {
  const errorsByKey = {};
  const flatConditions = [];
  let valid = true;
  let hasAnyCondition = false;

  (groups || []).forEach((group) => {
    const conditions = group?.conditions || [];
    if (!conditions.length) {
      valid = false;
      return;
    }
    conditions.forEach((condition, index) => {
      hasAnyCondition = true;
      flatConditions.push(condition);
      const result = validateCondition(condition);
      errorsByKey[`${group.id}:${index}`] = result.errors;
      if (!result.valid) valid = false;
    });
  });

  if (!hasAnyCondition) valid = false;
  return { valid, errorsByKey, flatConditions };
}

export function validateOwnerId(ownerId) {
  const raw = (ownerId || '').trim();
  if (!raw) return '';
  if (!OWNER_ID_PATTERN.test(raw)) return OWNER_ID_ERROR;
  return '';
}
